import React from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'

class HomePage extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      // DO NOT remove the legacy state below
      // role: null
    }
  }

  // DO NOT remove the legacy props checking below
  // componentWillReceiveProps = (nextProps) => {
  //   if (nextProps.auth.user) {
  //     this.setState({ role: nextProps.auth.user.role })
  //   }
  // }

  render () {
    const { auth } = this.props
    if (auth.user && auth.user.role === 'admin') {
      return <Redirect to={'/destination/manage'} />
    } else if (auth.user && auth.user.role !== 'admin') {
      return <Redirect to={'/order'} />
    } else if (!auth.user) {
      return <Redirect to={'/login'} />
    } else {
      return (
        <div>
          <header className='section'>
            <div className='title-block'>
              <h3 className='title'>Attraction Dashboard</h3>
            </div>
          </header>
        </div>
      )
    }
  }
}

const stateToProps = (state) => ({
  preset: state.preset,
  auth: state.auth
})

const dispatchToProps = (dispatch) => ({})

export default connect(stateToProps, dispatchToProps)(HomePage)



// WEBPACK FOOTER //
// ./src/Pages/HomePage.js